import { useEffect, useState } from "react";

import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

import {
  Box,
  Button,
  Container,
  Drawer,
  Hidden,
  IconButton,
  MenuItem,
  Toolbar,
  makeStyles,
} from "@material-ui/core";
import { Menu, OpenInNew } from "@material-ui/icons";

import { useApp } from "@ip-contexts/app-context";
import { usePermission } from "@ip-hooks";
import { publicPath } from "@ip-utils";

import routes from "../../Routes";
import Department from "./Department";

const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: theme.palette.common.white05,
    color: theme.palette.common.white,
    marginRight: theme.spacing(1),
    "&.active": {
      backgroundColor: theme.palette.iglu.cobaltBlue,
    },
    "&.inactive": {
      backgroundColor: theme.palette.iglu.denimBlue,
    },
  },
  drawerIcon: {
    color: theme.palette.common.white50,
  },
}));

function Navigation({ mobile }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [navItems, setNavItems] = useState([]);
  const classes = useStyles();
  const { hasPermission } = usePermission();
  const {
    state: { department, path },
  } = useApp();

  const currentDepartmentPath = `/${department}`;

  useEffect(() => {
    if (loading) {
      setLoading(false);

      const currentDepartment = routes.find((r) =>
        r.path.includes(currentDepartmentPath)
      );
      const items = currentDepartment.subRoutes.filter((route) => {
        if (route.hidden) {
          return false;
        }
        if (!route.path.includes(":") && route.path !== "") {
          return hasPermission(route.path);
        }
        return false;
      });

      setNavItems(items);
    }
  }, [hasPermission, loading, currentDepartmentPath]);

  function handleDrawerOpen() {
    setDrawerOpen(true);
  }

  function handleDrawerClose() {
    setDrawerOpen(false);
  }

  if (mobile) {
    return (
      <Hidden smUp>
        <IconButton size="small" onClick={handleDrawerOpen}>
          <Menu className={classes.drawerIcon} />
        </IconButton>
        <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerClose}>
          <Box
            bgcolor="iglu.denimBlue95"
            color="common.white"
            padding={3}
            marginBottom={3}
            minHeight={32}
          >
            {Object.keys(navItems).length > 1 ? (
              <Department />
            ) : (
              <Box
                alt="iglu"
                component="img"
                display="block"
                height={32}
                width={100}
                src={publicPath("/media/iglu-white.svg")}
              />
            )}
          </Box>
          {navItems.map((item, key) =>
            item.url ? (
              <MenuItem
                component="a"
                key={key}
                href={item.url}
                rel="noopener noreferrer"
                target="_blank"
              >
                <Box
                  alignItems="center"
                  display="flex"
                  justifyContent="space-between"
                  width="100%"
                >
                  {item.name}
                  <OpenInNew fontSize="inherit" />
                </Box>
              </MenuItem>
            ) : (
              <MenuItem
                activeClassName="Mui-selected"
                component={NavLink}
                key={key}
                to={`${currentDepartmentPath}${item.path}`}
                onClick={handleDrawerClose}
              >
                {item.name}
              </MenuItem>
            )
          )}
        </Drawer>
      </Hidden>
    );
  }

  return (
    <Hidden xsDown>
      <Box bgcolor="iglu.denimBlue" displayPrint="none">
        <Container>
          <Toolbar disableGutters>
            {navItems.map((item, key) =>
              currentDepartmentPath + item.path === path ? (
                <Button
                  className={`${classes.button} active`}
                  component="a"
                  key={key}
                  href={item.url}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {item.name}
                </Button>
              ) : (
                <Button
                  className={`${classes.button} inactive`}
                  component={NavLink}
                  key={key}
                  to={`${currentDepartmentPath}${item.path}`}
                >
                  {item.name}
                </Button>
              )
            )}
          </Toolbar>
        </Container>
      </Box>
    </Hidden>
  );
}

const mapStateToProps = (store) => ({
  user: store.user,
});

export default connect(mapStateToProps)(Navigation);
